import { render, staticRenderFns } from "./All-recipes.vue?vue&type=template&id=693fc93e&scoped=true&"
import script from "./All-recipes.vue?vue&type=script&lang=js&"
export * from "./All-recipes.vue?vue&type=script&lang=js&"
import style0 from "./All-recipes.vue?vue&type=style&index=0&id=693fc93e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693fc93e",
  null
  
)

export default component.exports